import { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../context/Context";
import ErrorToast from "../toasts/ErrorToast";
import { GetDeviceOwnerShipStatus, UpdateDeviceOwnerShip, UpdateEquipmentButton } from "../../api/api";
import SuccessToast from "../toasts/SuccessToast";
import WarningAlert from "../sweeAlerts/WarningAlert";

const EditChartNumberModal = ({ button }) => {
  const {
    setEditChartNumberModal,
    setEquipmentButtons,
    equipmentButtons,
    handleDefineChartModal,
    setUpdate,
  } = useContext(Context);

  const [chartNumber, setChartNumber] = useState();

  const modalName = useRef(null);
  const closeButton = useRef(null);

  useEffect(() => {
    setEditChartNumberModal(modalName);
    setChartNumber(button.data5 ? button.data5 : 0);
  }, [button]);

  const handleNumericValue = (value, min, max, setValue) => {
    const numericValue = Number(value);

    if (!Number.isInteger(numericValue)) {
      return setValue("");
    }
    if (numericValue <= min) {
      return setValue(min);
    } else if (numericValue >= max) {
      return setValue(max);
    }

    setValue(numericValue);
  };

  const handleSubmitChartNumber = () => {
    if (chartNumber == 0 || chartNumber == "")
      return ErrorToast("شماره نمودار را وارد کنید");

    UpdateEquipmentButton({
      equipment_button_id: button.id,
      name: button.name,
      digit: button.digit,
      icon: button.icon,
      data: [
        button.data1,
        button.data2,
        button.data3,
        button.data4,
        chartNumber,
      ],
    }).then((res) => {
      const index = equipmentButtons.findIndex((item) => item.id === button.id);

      if (index !== -1) {
        const updatedButtons = [...equipmentButtons];
        updatedButtons[index] = {
          ...updatedButtons[index],
          data5: chartNumber,
        };

        setEquipmentButtons(updatedButtons);
        SuccessToast("شماره نمودار با موفقیت ثبت شد");
        closeButton.current.click();
      }
    });
  };

  const handleDefineChart = (device) => {
    GetDeviceOwnerShipStatus({
      device_id: device.id
    }).then(({data}) => {
      if(data.status){
        handleDefineChartModal();
        setUpdate((prev) => !prev);
      }else {
        handleConnectToWallet(device, () => {
          handleDefineChartModal();
          setUpdate((prev) => !prev);
        })
      }
    })
  };

  const handleConnectToWallet = (device, callback = null) => {
    WarningAlert(
      "",
      "در صورت تایید، هزینه‌های مربوط به ثبت داده از حساب کیف پول شما کسر خواهد شد",
      "تایید",
      "انصراف"
    ).then(function (result) {
      if (result.value) {
        UpdateDeviceOwnerShip({ device_id: device.id }).then((res) => {
          if(res.data.status){
            SuccessToast(res.data.message);
            if (callback && typeof callback === "function") {
              callback();
            }
          }else{
            ErrorToast(res.data.message);
          }
        });
      }
    });
  };

  return (
    // Modal
    <div
      className="modal fade"
      id="backupModal"
      tabIndex="-1"
      aria-labelledby="changeNameModal"
      aria-hidden="true"
      ref={modalName}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="changeNameModal">
              تنظیم نمودار
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <div className="input-group">
              <button
                className="btn btn-success-app"
                type="button"
                id="button-addon1"
                onClick={() => handleSubmitChartNumber()}
              >
                ثبت شماره نمودار
              </button>
              <input
                type="text"
                className="form-control"
                value={chartNumber}
                onChange={(e) =>
                  handleNumericValue(e.target.value, 0, 16, setChartNumber)
                }
                placeholder="شماره نمودار را وارد کنید (16 - 1)"
                aria-describedby="button-addon1"
              />
            </div>
            <div className="form-text">
              در صورت اطلاع از شماره نمودار، آن را وارد کنید و در غیر این صورت
              بر روی دکمه تعریف کلیک کنید
            </div>
            <div>
              <button
                className="btn btn-success-app w-100 mt-4"
                type="button"
                onClick={() => handleDefineChart(button.device)}
              >
                تعریف
              </button>
            </div>
          </div>
          {/* <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-success-app mb-2"
              data-bs-dismiss="modal"
            >
              انصراف
            </button>
            <button
              type="button"
              className="btn btn-success-app mb-2"
              onClick={handleSubmit}
            >
              تایید
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default EditChartNumberModal;
